import axios from "axios";

const PREFOOTER_PROMOCODE = '/api/user/phones/create_lead'

export const getPromo = (data) => axios.post(PREFOOTER_PROMOCODE, data)
